import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  courseMaterial: {
    id: 'learn.navigation.course.tabs.label',
    defaultMessage: 'Course Material',
    description: 'The accessible label for course tabs navigation',
  },
  overviewText: {
    id: 'learn.navigation.course.tabs.button.text',
    defaultMessage: 'Project Menu',
    description: 'Overview button text of course tabs navigation',
  },
  "Coordinator Tracking" : {
    id: 'courseware.course.sidebar.link.coordinator.tracking',
    defaultMessage: 'Coordinator Tracking',
    description: 'Course coodinator tracking link text',
  },
  Course: {
    id: 'courseware.course.sidebar.link.overview',
    defaultMessage: 'Overview',
    description: 'Course overview link text',
  },
});

export default messages;
